
    <template>
      <section class="content element-doc">
        <h2 id="zhe-die-hua-kuai-zu-jian"><a class="header-anchor" href="#zhe-die-hua-kuai-zu-jian">¶</a> 折叠滑块组件</h2>
<h3 id="ji-ben-yong-fa"><a class="header-anchor" href="#ji-ben-yong-fa">¶</a> 基本用法</h3>
<demo-block>
        
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;sh-slider minheight=&quot;40px&quot; maxheight=&quot;300px&quot; showRefresh @search=&quot;onSearch&quot; @refresh=&quot;onRefresh&quot;&gt;
    &lt;el-form :inline=&quot;true&quot; label-position=&quot;left&quot; class=&quot;vault-filter filter-form&quot;&gt;
      &lt;el-form-item label=&quot;Name&quot;&gt;
        &lt;el-input v-model=&quot;name&quot; placeholder=&quot;Name&quot;&gt;&lt;/el-input&gt;
      &lt;/el-form-item&gt;
      &lt;el-form-item label=&quot;Description&quot;&gt;
        &lt;el-input v-model=&quot;description&quot; placeholder=&quot;Description&quot;&gt;&lt;/el-input&gt;
      &lt;/el-form-item&gt;
      &lt;el-form-item label=&quot;Description&quot;&gt;
        &lt;el-input v-model=&quot;description&quot; placeholder=&quot;Description&quot;&gt;&lt;/el-input&gt;
      &lt;/el-form-item&gt;
      &lt;el-form-item label=&quot;Description&quot;&gt;
        &lt;el-input v-model=&quot;description&quot; placeholder=&quot;Description&quot;&gt;&lt;/el-input&gt;
      &lt;/el-form-item&gt;
      &lt;el-form-item label=&quot;Description&quot;&gt;
        &lt;el-input v-model=&quot;description&quot; placeholder=&quot;Description&quot;&gt;&lt;/el-input&gt;
      &lt;/el-form-item&gt;
      &lt;el-form-item label=&quot;Description&quot;&gt;
        &lt;el-input v-model=&quot;description&quot; placeholder=&quot;Description&quot;&gt;&lt;/el-input&gt;
      &lt;/el-form-item&gt;
    &lt;/el-form&gt;
  &lt;/sh-slider&gt;
&lt;/template&gt;

&lt;script&gt;
  export default {
    data() {
      return {
        name: '',
        description: ''
      }
    },
    methods: {
      // 查询
      onSearch() {
        console.log('onSearch1')
      },
      // 刷新
      onRefresh() {
        console.log('onRefresh')
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h3 id="zi-ding-yi-you-ce-an-niu-kong-jian"><a class="header-anchor" href="#zi-ding-yi-you-ce-an-niu-kong-jian">¶</a> 自定义右侧按钮控件</h3>
<demo-block>
        
        <template slot="source"><element-demo1 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;sh-slider minheight=&quot;40px&quot; maxheight=&quot;300px&quot; size=&quot;small&quot; @search=&quot;onSearch&quot; @refresh=&quot;onRefresh&quot;&gt;
    &lt;el-form :inline=&quot;true&quot; label-position=&quot;left&quot; class=&quot;vault-filter filter-form&quot;&gt;
      &lt;el-form-item label=&quot;Name&quot;&gt;
        &lt;el-input v-model=&quot;name&quot; placeholder=&quot;Name&quot;&gt;&lt;/el-input&gt;
      &lt;/el-form-item&gt;
      &lt;el-form-item label=&quot;Description&quot;&gt;
        &lt;el-input v-model=&quot;description&quot; placeholder=&quot;Description&quot;&gt;&lt;/el-input&gt;
      &lt;/el-form-item&gt;
      &lt;el-form-item label=&quot;Description&quot;&gt;
        &lt;el-input v-model=&quot;description&quot; placeholder=&quot;Description&quot;&gt;&lt;/el-input&gt;
      &lt;/el-form-item&gt;
      &lt;el-form-item label=&quot;Description&quot;&gt;
        &lt;el-input v-model=&quot;description&quot; placeholder=&quot;Description&quot;&gt;&lt;/el-input&gt;
      &lt;/el-form-item&gt;
      &lt;el-form-item label=&quot;Description&quot;&gt;
        &lt;el-input v-model=&quot;description&quot; placeholder=&quot;Description&quot;&gt;&lt;/el-input&gt;
      &lt;/el-form-item&gt;
      &lt;el-form-item label=&quot;Description&quot;&gt;
        &lt;el-input v-model=&quot;description&quot; placeholder=&quot;Description&quot;&gt;&lt;/el-input&gt;
      &lt;/el-form-item&gt;
      &lt;el-form-item label=&quot;Description&quot;&gt;
        &lt;el-input v-model=&quot;description&quot; placeholder=&quot;Description&quot;&gt;&lt;/el-input&gt;
      &lt;/el-form-item&gt;
    &lt;/el-form&gt;
    &lt;template #btns=&quot;{ onOpen }&quot;&gt;
      &lt;div&gt;
        &lt;el-button type=&quot;primary&quot; size=&quot;small&quot; @click=&quot;onSearch&quot;&gt;Search&lt;/el-button&gt;
        &lt;el-button type=&quot;primary&quot; @click=&quot;onOpen&quot; size=&quot;small&quot; icon=&quot;el-icon-arrow-up&quot;&gt;&lt;/el-button&gt;
      &lt;/div&gt;
    &lt;/template&gt;
  &lt;/sh-slider&gt;
&lt;/template&gt;

&lt;script&gt;
  export default {
    data() {
      return {
        name: '',
        description: ''
      }
    },
    methods: {
      // 查询
      onSearch() {
        console.log('onSearch1')
      },
      // 刷新
      onRefresh() {
        console.log('onRefresh')
      }
    }
  }
&lt;/script&gt;

&lt;style&gt;&lt;/style&gt;
</code></pre></template></demo-block><h3 id="bao-liu-zhe-die-an-niu-qi-ta-zi-ding-yi"><a class="header-anchor" href="#bao-liu-zhe-die-an-niu-qi-ta-zi-ding-yi">¶</a> 保留折叠按钮其他自定义</h3>
<demo-block>
        
        <template slot="source"><element-demo2 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;div&gt;
    &lt;sh-slider minheight=&quot;40px&quot; maxheight=&quot;300px&quot; size=&quot;small&quot; showRefresh @search=&quot;onSearch&quot; @refresh=&quot;onRefresh&quot;&gt;
      &lt;el-form :inline=&quot;true&quot; label-position=&quot;left&quot; class=&quot;vault-filter filter-form&quot;&gt;
        &lt;el-form-item label=&quot;Name&quot;&gt;
          &lt;el-input v-model=&quot;name&quot; placeholder=&quot;Name&quot;&gt;&lt;/el-input&gt;
        &lt;/el-form-item&gt;
        &lt;el-form-item label=&quot;Description&quot;&gt;
          &lt;el-input v-model=&quot;description&quot; placeholder=&quot;Description&quot;&gt;&lt;/el-input&gt;
        &lt;/el-form-item&gt;
        &lt;el-form-item label=&quot;Description&quot;&gt;
          &lt;el-input v-model=&quot;description&quot; placeholder=&quot;Description&quot;&gt;&lt;/el-input&gt;
        &lt;/el-form-item&gt;
        &lt;el-form-item label=&quot;Description&quot;&gt;
          &lt;el-input v-model=&quot;description&quot; placeholder=&quot;Description&quot;&gt;&lt;/el-input&gt;
        &lt;/el-form-item&gt;
        &lt;el-form-item label=&quot;Description&quot;&gt;
          &lt;el-input v-model=&quot;description&quot; placeholder=&quot;Description&quot;&gt;&lt;/el-input&gt;
        &lt;/el-form-item&gt;
        &lt;el-form-item label=&quot;Description&quot;&gt;
          &lt;el-input v-model=&quot;description&quot; placeholder=&quot;Description&quot;&gt;&lt;/el-input&gt;
        &lt;/el-form-item&gt;
        &lt;el-form-item label=&quot;Description&quot;&gt;
          &lt;el-input v-model=&quot;description&quot; placeholder=&quot;Description&quot;&gt;&lt;/el-input&gt;
        &lt;/el-form-item&gt;
      &lt;/el-form&gt;
      &lt;template #btns-left&gt;
        &lt;div class=&quot;slider-btns&quot;&gt;
          &lt;el-button type=&quot;primary&quot; size=&quot;small&quot; @click=&quot;onSearch&quot;&gt;Search&lt;/el-button&gt;
        &lt;/div&gt;
      &lt;/template&gt;
    &lt;/sh-slider&gt;
  &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
  export default {
    data() {
      return {
        name: '',
        description: ''
      }
    },
    methods: {
      // 查询
      onSearch() {
        console.log('onSearch1')
      },
      // 刷新
      onRefresh() {
        console.log('onRefresh')
      }
    }
  }
&lt;/script&gt;

&lt;style&gt;&lt;/style&gt;
</code></pre></template></demo-block><h3 id="attributes"><a class="header-anchor" href="#attributes">¶</a> Attributes</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>packup</td>
<td>是否默认折叠</td>
<td>boolean</td>
<td>-</td>
<td>true</td>
</tr>
<tr>
<td>minheight</td>
<td>最小高度</td>
<td>string</td>
<td>-</td>
<td>'50px</td>
</tr>
<tr>
<td>maxheight</td>
<td>最大高度</td>
<td>string</td>
<td>-</td>
<td>'300px'</td>
</tr>
<tr>
<td>show-refresh</td>
<td>是否显示刷新按钮</td>
<td>boolean</td>
<td>-</td>
<td>false</td>
</tr>
<tr>
<td>show-search</td>
<td>是否显示查询按钮</td>
<td>boolean</td>
<td>-</td>
<td>true</td>
</tr>
<tr>
<td>btn-type</td>
<td>折叠按钮类型</td>
<td>string</td>
<td>继承 el-button 类型</td>
<td>'primary'</td>
</tr>
<tr>
<td>search-config</td>
<td>查询按钮配置项</td>
<td>object</td>
<td>-</td>
<td>{type:'primary',icon:'el-icon-search'}</td>
</tr>
<tr>
<td>refresh-config</td>
<td>刷新按钮配置项</td>
<td>object</td>
<td>-</td>
<td>{type:'primary',icon:'el-icon-refresh'}</td>
</tr>
<tr>
<td>btn-padding</td>
<td>按钮边距</td>
<td>number</td>
<td>-</td>
<td>16</td>
</tr>
<tr>
<td>size</td>
<td>按钮尺寸</td>
<td>string</td>
<td>medium / small / mini</td>
<td>-</td>
</tr>
</tbody>
</table>
<h3 id="events"><a class="header-anchor" href="#events">¶</a> Events</h3>
<table>
<thead>
<tr>
<th>事件名称</th>
<th>说明</th>
<th>回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>search</td>
<td>点击查询按钮时</td>
<td>-</td>
</tr>
<tr>
<td>refresh</td>
<td>点击刷新按钮时</td>
<td>-</td>
</tr>
</tbody>
</table>
<h3 id="slot"><a class="header-anchor" href="#slot">¶</a> Slot</h3>
<table>
<thead>
<tr>
<th>名称</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>default</td>
<td>折叠内容</td>
</tr>
<tr>
<td>btns</td>
<td>自定义右侧控件,参数为{open,onOpen}</td>
</tr>
<tr>
<td>btns-left</td>
<td>折叠按钮左侧内容</td>
</tr>
</tbody>
</table>

      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('sh-slider',{attrs:{"minheight":"40px","maxheight":"300px","showRefresh":""},on:{"search":_vm.onSearch,"refresh":_vm.onRefresh}},[_c('el-form',{staticClass:"vault-filter filter-form",attrs:{"inline":true,"label-position":"left"}},[_c('el-form-item',{attrs:{"label":"Name"}},[_c('el-input',{attrs:{"placeholder":"Name"},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Description"}},[_c('el-input',{attrs:{"placeholder":"Description"},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Description"}},[_c('el-input',{attrs:{"placeholder":"Description"},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Description"}},[_c('el-input',{attrs:{"placeholder":"Description"},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Description"}},[_c('el-input',{attrs:{"placeholder":"Description"},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Description"}},[_c('el-input',{attrs:{"placeholder":"Description"},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1)],1)],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
    data() {
      return {
        name: '',
        description: ''
      }
    },
    methods: {
      // 查询
      onSearch() {
        console.log('onSearch1')
      },
      // 刷新
      onRefresh() {
        console.log('onRefresh')
      }
    }
  }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo1": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('sh-slider',{attrs:{"minheight":"40px","maxheight":"300px","size":"small"},on:{"search":_vm.onSearch,"refresh":_vm.onRefresh},scopedSlots:_vm._u([{key:"btns",fn:function(ref){
var onOpen = ref.onOpen;
return [_c('div',[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.onSearch}},[_vm._v("Search")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small","icon":"el-icon-arrow-up"},on:{"click":onOpen}})],1)]}}])},[_c('el-form',{staticClass:"vault-filter filter-form",attrs:{"inline":true,"label-position":"left"}},[_c('el-form-item',{attrs:{"label":"Name"}},[_c('el-input',{attrs:{"placeholder":"Name"},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Description"}},[_c('el-input',{attrs:{"placeholder":"Description"},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Description"}},[_c('el-input',{attrs:{"placeholder":"Description"},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Description"}},[_c('el-input',{attrs:{"placeholder":"Description"},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Description"}},[_c('el-input',{attrs:{"placeholder":"Description"},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Description"}},[_c('el-input',{attrs:{"placeholder":"Description"},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Description"}},[_c('el-input',{attrs:{"placeholder":"Description"},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1)],1)],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
    data() {
      return {
        name: '',
        description: ''
      }
    },
    methods: {
      // 查询
      onSearch() {
        console.log('onSearch1')
      },
      // 刷新
      onRefresh() {
        console.log('onRefresh')
      }
    }
  }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo2": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('sh-slider',{attrs:{"minheight":"40px","maxheight":"300px","size":"small","showRefresh":""},on:{"search":_vm.onSearch,"refresh":_vm.onRefresh},scopedSlots:_vm._u([{key:"btns-left",fn:function(){return [_c('div',{staticClass:"slider-btns"},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.onSearch}},[_vm._v("Search")])],1)]},proxy:true}])},[_c('el-form',{staticClass:"vault-filter filter-form",attrs:{"inline":true,"label-position":"left"}},[_c('el-form-item',{attrs:{"label":"Name"}},[_c('el-input',{attrs:{"placeholder":"Name"},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Description"}},[_c('el-input',{attrs:{"placeholder":"Description"},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Description"}},[_c('el-input',{attrs:{"placeholder":"Description"},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Description"}},[_c('el-input',{attrs:{"placeholder":"Description"},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Description"}},[_c('el-input',{attrs:{"placeholder":"Description"},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Description"}},[_c('el-input',{attrs:{"placeholder":"Description"},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Description"}},[_c('el-input',{attrs:{"placeholder":"Description"},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1)],1)],1)],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
    data() {
      return {
        name: '',
        description: ''
      }
    },
    methods: {
      // 查询
      onSearch() {
        console.log('onSearch1')
      },
      // 刷新
      onRefresh() {
        console.log('onRefresh')
      }
    }
  }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  